// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3ZvnT","header":"MessagesList_header__2Y74G","chat":"MessagesList_chat__o7qJL"};